export default __webpack_public_path__ + "static/media/stage-now-3.fb7218e7.svg";